<div class="container margin-top-20">
  <div class="row">
    <div class="col-md-4 col-md-offset-4">
       <form class="register" (ngSubmit)="RegisterPhoneNumber()" #userNumberForm="ngForm">
        <div class="row margin-bottom-10">
          <div class="col-md-12">
            <div class="form-group" [class.has-error]="phoneNumberControl.invalid && phoneNumberControl.touched"
              [class.has-success]="phoneNumberControl.valid">
              <label for="phoneNumber" class="control-label"> Phone Number:<i class="fa fa-asterisk"></i></label>
              <input type="text" (click)="pastOnClick($event.target)" class="input-text" [(ngModel)]="PhoneNumber"
                name="phoneNumber" id="phoneNumber" value="" #phoneNumberControl="ngModel" required />
              <div *ngIf="phoneNumberTaken" class="notification error closeable">
                <p>Phone number is already registered</p>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
